export default {
  PAYMENTS_LIST: "Liste des paiements",
  ADD_PAYMENT: "Ajouter un paiement",
  PAYMENT_ADDED: "Paiement ajouté",
  AUTHORIZATIONS: "Autorisations",
  EDIT_PAYMENT: "Modifier le paiement",
  PAYMENT_SOURCE_MANUAL: "Manuel",
  PAYMENT_SOURCE_PAYPAL: "Paypal",
  PAYMENT_SOURCE_STRIPE: "Stripe",
  SOURCE: "Source",
  TRANSACTION_ID: "Id transaction",
  TRANSACTION_DATA: "Données transaction",
  SOURCE_DETAILS: "Détail des paiements",
  AWAITING_DPA_CONTRACT_SIGNATURE: "En attente de Signature",
  HOLDON: "Mise en attente",
  SENT: "Envoyé au DPA",
  PAYMENT_SENT_TO_DPA: "Paiement envoyé au DPA !",
  SENT_TO_BANK: "Envoyé à la banque",
  DPA_CONTRACT_SIGNATURE_DECLINED: "Signature refusée",
  DRAFT: "Brouillon",
  AWAITING_SIGNATURE: "En attente de signature",
  COMPLETED: "Complétée",
  REFUSED: "Refusée",
  CANCELED: "Annulé",
  PENDING: "En cours",
  MANUAL: "Manuel",
  STRIPE: "Stripe",
  PAYPAL: "Paypal",
  CASH: "Espèce",
  DPA: "DPA",
  UNKNOWN:"Autre",
  CHECK: "Chèque",
  TRANSACTIONS: "Transactions DPA",
  DELETE_THIS_PAYMENT: "Supprimer ce paiement ?",
  FOR_THE_SELECTED_TRANSACTION: "Pour la transaction sélectionnée",
  FOR_THE_SELECTED_TRANSACTIONS: "Pour les {nb} transactions sélectionnées",
  PUT_ON_HOLD:"Mettre en attente",
  PUT_THIS_PAYMENT_ON_HOLD:"Mettre cette transaction en attente ?",
  PUT_THOSE_PAYMENTS_ON_HOLD:"Mettre ces transactions en attente ?",
  STATUS_CHANGED: "Le statut du paiement a bien été modifié !",
  PUT_ON_PENDING:"Remettre en traitement",
  PAYMENTS_TRANSACTIONS_LIST: "Liste des transactions paiements",
  PUT_THOSE_PAYMENTS_ON_PENDING:"Remettre ces transactions en traitement ?",
  PUT_THIS_PAYMENT_ON_PENDING:"Remettre cette transaction en traitement ?",
  SEND_THIS_PAYMENT_TO_DPA: "Envoyer cette transaction au DPA ?",
  SEND_THOSE_PAYMENTS_TO_DPA: "Envoyer ces transactions au DPA ?",
  CANT_BE_SENT: "Vous ne pouvez envoyer au DPA que des transactions en cours !",
  SEND_TO_DPA: "Envoyer au DPA",
  PURCHASE: "Achat",
  SALE: "Vente",
  SELECT_SAME_STATUS_TO_SHOW_OPTIONS: "Sélectionnez les transactions de même statut pour afficher les options.",
  PAIED:"Payé",
  SELECT_SOURCE: "Veuillez sélectionner la source.",
  PAYMENT_SOURCE:"Mode du paiement",
  REFUND_PAYMENT_SOURCE:"Mode du paiement du remboursement",
  PAYMENT_NOTE:"Un détails ou une note sur le paiement",
  SELECT_PAYMENT_ACCOUNT:"Sélectionner un compte",
  SELECT_SOURCE_ACCOUNT: "Veuillez sélectionner un compte",
  REFUND_WILL_BE_GENERATED: "Un remboursement sera généré pour cette annulation.",
  REFUND: "Remboursement",
  INVOICE_HAS_PAYMENTS_TO_REFUND: "Cette facture a des paiements à rembourser.",
};
